import { render, staticRenderFns } from "./dao.vue?vue&type=template&id=a4d89a54&scoped=true&"
import script from "./dao.vue?vue&type=script&lang=js&"
export * from "./dao.vue?vue&type=script&lang=js&"
import style0 from "./dao.vue?vue&type=style&index=0&id=a4d89a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d89a54",
  null
  
)

export default component.exports